import React, { useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useParams } from "react-router-dom";

function AdminOfferApprovalModel({ selectedOffer, isModalOpen, closeModal, status, onStatusUpdate }) {

    const [loading, setLoading] = useState(false);

    const handleStatusUpdate = async () => {
        if (!selectedOffer || !status) return;
        setLoading(true);
        try {
            const res = await USER_URL.post(
                `/products/admin/special-offer/${selectedOffer.id}/`,
                { status }
            );
            console.log("Response:", res.data);
            onStatusUpdate(selectedOffer.id, status); // Update status in the parent component
            closeModal();
        } catch (error) {
            console.error("Error updating status:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {isModalOpen && selectedOffer && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
                    <div className="bg-white p-6 rounded-xl shadow-2xl max-w-lg w-full relative">
                        {/* Close Button */}
                        <button
                            className="absolute top-3 right-3 text-gray-700 hover:text-red-500 transition duration-200"
                            onClick={closeModal}
                        >
                            <IoCloseSharp size={24} />
                        </button>

                        {/* Offer Image */}
                        <div className="flex justify-center mb-4">
                            <img
                                src={`${BASE_URL}${selectedOffer.banner}`}
                                alt="Offer Banner"
                                className="w-full h-48 object-contain rounded-lg"
                            />
                        </div>

                        {/* Offer Title */}
                        <h2 className="text-2xl font-bold text-gray-800 text-center">Title : {selectedOffer.title}</h2>
                        {/* <p className="text-lg font-semibold text-center text-gray-600 mt-2">Status: {status}</p> */}

                        {/* Offer Dates */}
                        <div className="mt-4 text-center">
                            <p className="text-md font-medium text-gray-700">Start Date: <span className="font-semibold">{selectedOffer.start_date}</span></p>
                            <p className="text-md font-medium text-gray-700">End Date: <span className="font-semibold">{selectedOffer.end_date}</span></p>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-center mt-6 space-x-4">
                            <button
                                className={`px-6 py-2 rounded-lg font-semibold transition duration-300 w-full ${status === "Approved"
                                        ? " border-green-500 text-green-500 border-2 hover:bg-green-500 hover:text-white"
                                        : "border-red-500 text-red-500 border-2 hover:bg-red-500 hover:text-white"
                                    }`}
                                onClick={handleStatusUpdate}
                                disabled={loading}
                            >
                                {loading ? "Processing..." : status}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminOfferApprovalModel;